import { TelecomProvider } from './telecom-provider.enum';

export const PROVIDER_OPTIONS: { value: TelecomProvider; label: string }[] = [
  { value: TelecomProvider.Vodafone, label: 'Settings::PhoneNumbers:Provider:Vodafone' },
  { value: TelecomProvider.Other, label: 'Settings::PhoneNumbers:Provider:Other' },
  { value: TelecomProvider.Twilio, label: 'Settings::PhoneNumbers:Provider:Twilio' },
  { value: TelecomProvider.Turkcell, label: 'Settings::PhoneNumbers:Provider:Turkcell' },
  { value: TelecomProvider.TurkTelekom, label: 'Settings::PhoneNumbers:Provider:TurkTelekom' },
];
